import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cm-recherche-resultat',

    template: `
        <div class="cadre-resultat-site row">

            <div class="col-xs-1 cadre-image-type">
                <img class="img img-responsive" [src]="obtenirIconeMarqueur(site)" />
            </div>

            <div class="col-xs-11">
                <div class="cadre-infos row">

                    <div class="cadre-infos-haut">
                        <h4>{{site.Nom}}</h4>
                        <div class="texte-description">{{site.Localisation}}</div>
                    </div>

                     <div class="cadre-evenement">
                        <div><img src="./assets/images/diagonal_border.png" height="50px" /></div>
                        <div class="texte-evenement" [innerHTML]="remplacerImageEvenement(site)"></div>
                    </div>
                </div>

            <div class="cadre-infos-bas row">
                <div class="col-md-3 cadre-image-sanctuaire">
                    <img [src]="obtenirImageSanctuaire(site)" class="image-sanctuaire img" />
                </div>
                <div class="col-md-9">
                    <div class="cadre-texte-presentation" [innerHTML]="site.Texte"></div>
                    <div class="barre-boutons">
                        <div class="bouton-savoir-plus text-center" (click)="selectionnerSite(site)"> En savoir plus </div>
                        <div *ngIf="favoris" class="texte-favoris text-center" (click)="enleverFavoris.emit(site)"> Supprimer des favoris </div>
                    </div>

                </div>
            </div>

            </div>
        </div>
    `,

    styles: [`
        .cadre-resultat-site {
            margin-top: 20px;
            background-color: white;
            padding-bottom: 10px;
        }
        .cadre-image-type {
            padding: 0;
            padding-left: 10px;
            padding-top: 15px;
            display: flex;
            justify-content: space-around;
        }
        .cadre-image-type img {
            height: 30px;
        }
        .cadre-infos {
            display:flex;
            margin-left: 2px;
        }
        .cadre-infos-haut {
            max-width:420px 
        }
        h4 {
            margin-bottom: 0px;
        }
        .texte-description {
            font-size: 14px;
            line-height:15px;
        }
        .cadre-evenement {
            background-color:rgb(201,202,202);
            height:50px;
            padding:0;
            display:flex; 
            position:absolute;
            right:0;
            top:0;
            padding-right:20px;
        }
        .texte-evenement {
            padding-top:12px;
        }
        .cadre-infos-bas {
            padding-top:4px;
        }
        .cadre-image-sanctuaire {
        }
        .image-sanctuaire {
            height:100px;
            max-width: 100%;
        }
        .cadre-texte-presentation {
            height:60px;
            overflow:hidden;
            margin-left: -15px;
            padding-right:10px;
        }
        .barre-boutons {
            display: flex;
            align-items: center;
        }
        .bouton-savoir-plus {
            cursor: pointer;
            height: 30px;
            margin-top: 6px;
            background-color: #FFA300;
            color: white;
            width: 150px;
            border-radius: 5px;
            font-size: 14px;
            padding-top: 5px;
        }
        .texte-favoris {
            padding-left: 20px;
            color: #FFA300;
            cursor: pointer;
            padding-top: 11px;
        }

        @media (max-width: 800px), (max-height: 700px) { 
            .cadre-image-type {
                padding-left: 3px;
            }
            .cadre-evenement {
                height:35px;
            }
            .texte-evenement {
                padding-top: 4px;
            }
            .cadre-infos-haut {
                max-width: 60vw;
            }
            .texte-favoris {
                padding-left: 10px;
                line-height: 15px;
            }
        }
    `]
})

export class RechercheResultatComponent implements OnInit {
    @Input() site: any;
    @Input() favoris: boolean;
    @Output() selectionner: EventEmitter<any> = new EventEmitter();
    @Output() enleverFavoris: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit() {
    }

    obtenirImageSanctuaire(site: any) {
      if (site.ImagePrincipale) {
          return `./assets/ImageSite/${site.Id}.jpg`;
          /*let myRegex = /<img[^>]+src="(http:\/\/[^">]+)"/g;
          let src = myRegex.exec(site.ImagePrincipale);
          return src[1];*/
      } else {
          return  './assets/images/church.jpg';
      }
  }

  remplacerImageEvenement(site: any) {
        let evenement = site.TypeEvenement.replace(/height="64"/g, 'height="30"');
        evenement = evenement.replace(/width="64"/g, 'width="30"');
        return evenement;
    }

  obtenirIconeMarqueur(site: any): any {
     return './assets/images/' + site.TypeSite;
  }

  selectionnerSite(site: any) {
    this.selectionner.emit(site);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/recherche-resultat.component.ts